/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Import_From_UrlInputs */

const en_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from URL`)
};

const de_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von URL importieren`)
};

const fr_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer depuis une URL`)
};

const es_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar desde URL`)
};

const it_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa da URL`)
};

const nl_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importeren van URL`)
};

const pl_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importuj z URL`)
};

const fi_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuo URL:stä`)
};

const da_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer fra URL`)
};

const sv_jobs_import_from_url = /** @type {(inputs: Jobs_Import_From_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importera från URL`)
};

/**
* | output |
* | --- |
* | "Import from URL" |
*
* @param {Jobs_Import_From_UrlInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_import_from_url = /** @type {((inputs?: Jobs_Import_From_UrlInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Import_From_UrlInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_import_from_url(inputs)
	if (locale === "fr") return fr_jobs_import_from_url(inputs)
	if (locale === "es") return es_jobs_import_from_url(inputs)
	if (locale === "it") return it_jobs_import_from_url(inputs)
	if (locale === "nl") return nl_jobs_import_from_url(inputs)
	if (locale === "pl") return pl_jobs_import_from_url(inputs)
	if (locale === "fi") return fi_jobs_import_from_url(inputs)
	if (locale === "da") return da_jobs_import_from_url(inputs)
	if (locale === "sv") return sv_jobs_import_from_url(inputs)
	return en_jobs_import_from_url(inputs)
});